/** Pieces shared by the page list, the page editor and the FAQ editor. */

export const PAGE_STATUS_OPTIONS = [
  { value: "published", label: "Published", hint: "Live on the site" },
  { value: "draft", label: "Draft", hint: "Hidden while it is being written" },
  { value: "hold", label: "On hold", hint: "Taken down on purpose" },
];

// Where each page lives on the storefront, for the "View on site" link and
// the Google preview. About us keeps its short key but is served at /aboutus.
export const PAGE_PATHS = {
  terms: "/terms",
  privacy: "/privacy",
  "shipment-policy": "/shipment-policy",
  "refund-policy": "/refund-policy",
  "points-policy": "/points-policy",
  faq: "/faq",
  about: "/aboutus",
};

export const SITE = "nysmah.com";

// Soft limits: Google cuts titles and descriptions at about these lengths.
// The counter warns; nothing refuses a longer one.
export const SEO_SOFT_LIMITS = { title: 60, description: 155 };

/**
 * The message to show for a failed request.
 *
 * The backend answers a refused save in two shapes: 400 with a list of what
 * was wrong with the form, or 422 with one sentence. Both are written for the
 * person filling the form, so they are shown as they come.
 */
export const errorText = (error, fallback) => {
  const body = error?.response?.data;
  if (Array.isArray(body?.response) && body.response.length) return body.response.join("\n");
  if (typeof body?.message === "string" && body.message) return body.message;
  if (typeof body?.response?.message === "string") return body.response.message;
  return fallback;
};

export const todayISO = () => new Date().toISOString().slice(0, 10);

export const formatDate = (iso) => {
  if (!iso) return "—";
  const date = new Date(iso.length === 10 ? `${iso}T00:00:00` : iso);
  return Number.isNaN(date.getTime())
    ? "—"
    : date.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
};
